import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, ButtonModel, DrawerContext } from '@notino/react-styleguide';

import { useTrackingContext } from '@context/tracking/TrackingContext';

import { normalizeCategory } from '../../Filters/helpers';
import { trackFiltration } from '../../Filters/tracking';
import { sortFilterBarMessages } from '../../messages';
import {
  useReviewFilterActions,
  useReviewFiltersStore,
} from '../../Stores/filtersStore';
import { useReviewSortingActions } from '../../Stores/sortingStore';

import { FooterButtonWrapper, FooterWrapper } from './styled';

export const Footer = () => {
  const { apply } = useReviewFilterActions();
  const { resetNextPage } = useReviewSortingActions();

  const selectedCategory = useReviewFiltersStore(
    (state) => state.currentCategory
  );
  const temporarySelections = useReviewFiltersStore(
    (state) => state.temporarySelections
  );

  const { getTimeFromInit } = useTrackingContext();

  const { closeDrawer } = DrawerContext.useDrawerContext();

  const handleApply = () => {
    apply();
    resetNextPage();
    closeDrawer();

    trackFiltration({
      interaction: 'filtration_view',
      timing: getTimeFromInit(),
      name: '',
      action: 'filtration_confirmed',
      type: normalizeCategory(selectedCategory ?? ''),
      filters: JSON.stringify(temporarySelections),
    });
  };

  return (
    <FooterWrapper>
      <FooterButtonWrapper>
        <Button buttonStyle={ButtonModel.Styles.primary} onClick={handleApply}>
          <FormattedMessage {...sortFilterBarMessages.apply} />
        </Button>
      </FooterButtonWrapper>
    </FooterWrapper>
  );
};
